import React, { useState, useEffect } from "react";
import gstImg from "../../Utils/assets/img/gst_img.png"
import Select from "react-select"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const GSTCalculator = () => {

    const [isInfoHovered, setInfoHovered] = useState(false)
    const [amount, setAmount] = useState("");
    const [gstRate, setGstRate] = useState("5");
    const [calcType, setCalcType] = useState("exclusive");

    const [results, setResults] = useState({
        baseAmount: 0,
        gstAmount: 0,
        // cgst: 0,
        // sgst: 0,
        totalAmount: 0,
    });

    const gstOptions = [
        { value: "5", label: "5% (Standard Essential)" },
        { value: "12", label: "12% (Standard Utility)" },
        { value: "18", label: "18% (Standard Services Matrix)" },
        { value: "28", label: "28% (Peak Premium Luxury)" },
    ];

    const statusDetails = [
        { label: "GST Exclusive", description: "GST Exclusive amount refers to the value of the product by subtracting the GST amount from the GST Inclusive value of the product." },
        { label: "GST Inclusive", description: "GST inclusive amount refers to the total value of the product after including the GST amount in the original value of the product. The tax is not charged separately from the customer." },
    ]


    useEffect(() => {
        const amt = parseFloat(amount) || 0;
        const rate = parseFloat(gstRate) || 0;

        let base = 0;
        let tax = 0;
        let total = 0;

        if (calcType === "exclusive") {
            base = amt;
            tax = amt * (rate / 100);
            total = amt + tax;
        } else {
            total = amt;
            base = amt / (1 + rate / 100);
            tax = amt - base;
        }

        setResults({
            baseAmount: Math.round(base * 100) / 100,
            gstAmount: Math.round(tax * 100) / 100,
            // cgst: Math.round((tax / 2) * 100) / 100, // Central GST
            // sgst: Math.round((tax / 2) * 100) / 100, // State GST
            totalAmount: Math.round(total * 100) / 100,
        });
    }, [amount, gstRate, calcType]);

    return (
        <div className="bg-white position-relative d-flex justify-content-center gap-5 align-items-center " style={{ height: "calc(100vh - 6rem)", overflow: 'hidden' }}>

            <div className="d-flex flex-column ">
                <div className="p-4 ps-0 d-flex justify-content-between" >
                    <div>
                        <h5 className="mb-1 fw-bold tracking-wide">GST Tax Assessment Tool</h5>
                        <p className="mb-0  small">Calculate compliance metrics for ledger accounting workflows</p>
                    </div>
                </div>

                <div>
                    <div className="mb-3">
                        <div className="position-relative">
                            <label className="form-label text-muted small fw-medium">Calculation Mode</label>
                            <div
                                className="position-absolute top-0 "
                                style={{ left: '7.5rem' }}
                                onMouseEnter={() => setInfoHovered(true)}
                                onMouseLeave={() => setInfoHovered(false)}
                            >
                                <button
                                    type="button"
                                    className="btn p-0 text-muted shadow-none "
                                    style={{ transition: "color 0.15s ease" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        style={{ fontSize: "16px" }}
                                    />
                                </button>

                                {isInfoHovered && (
                                    <div
                                        className="position-absolute"
                                        style={{
                                            top: "110%",
                                            right: 0,
                                            width: "320px",
                                            background: "#fff",
                                            border: "1px solid #e0e4f8",
                                            borderRadius: "8px",
                                            padding: "12px",
                                            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                                            zIndex: 1000,
                                        }}
                                    >

                                        {statusDetails.map((c) => (
                                            <div
                                                key={c.label}
                                                style={{
                                                    marginBottom: "10px",
                                                    paddingBottom: "10px",
                                                    borderBottom: "1px solid #f1f3f8",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 600,
                                                        color: "#2e384d",
                                                        marginBottom: "4px",
                                                    }}
                                                >
                                                    {c.label}
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#6b7280",
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    {c.description}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="d-flex gap-2 p-1 bg-light rounded-2 border">
                            <button
                                type="button"
                                className={`btn btn-sm flex-fill fw-medium border-0 py-2 rounded-2 transition-all ${calcType === "exclusive" ? "bg-white text-dark shadow-sm" : "text-secondary"}`}
                                onClick={() => setCalcType("exclusive")}
                                style={{ fontSize: "13px" }}
                            >
                                GST Exclusive
                            </button>
                            <button
                                type="button"
                                className={`btn btn-sm flex-fill fw-medium border-0 py-2 rounded-2 transition-all ${calcType === "inclusive" ? "bg-white text-dark shadow-sm" : "text-secondary"}`}
                                onClick={() => setCalcType("inclusive")}
                                style={{ fontSize: "13px" }}
                            >
                                GST Inclusive
                            </button>
                        </div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="gst-amount" className="form-label text-muted small fw-semibold">Initial Amount (₹)</label>
                        <div className="input-group border rounded-2 overflow-hidden shadow-xs">
                            <span className="input-group-text border-0 bg-light text-secondary fw-semibold">₹</span>
                            <input
                                id="gst-amount"
                                type="number"
                                className="form-control border-0 shadow-none py-2"
                                placeholder="Enter raw currency value"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                style={{ fontSize: "14px" }}
                            />
                        </div>
                    </div>

                    <div className="mb-2">
                        <label htmlFor="gst-percentage" className="form-label text-muted small fw-semibold">Tax Slab Rate</label>
                        <Select
                            inputId="gst-percentage"
                            options={gstOptions}
                            value={gstOptions.find((option) => option.value === gstRate)}
                            onChange={(selectedOption) => setGstRate(selectedOption.value)}
                            isSearchable={false}
                        />
                    </div>
                </div>

                <div className="mt-4 p-3 rounded-3 border d-flex align-items-center justify-content-evenly" style={{ backgroundColor: "#fef8fa", borderColor: "#f7d6e6", maxHeight: "auto" }}>
                    <div>
                        <span className="fw-medium text-uppercase tracking-wider d-block mb-1 text-muted" style={{ fontSize: "10px", }}>Total GST Amount</span>
                        <span className="fs-5 fw-black" >
                            ₹{results.gstAmount.toLocaleString('en-IN')}
                        </span>
                    </div>
                    <span style={{ height: '4rem', width: "2px", background: '#ececec' }} />
                    <div>
                        <span className="fw-medium text-uppercase tracking-wider d-block mb-1 text-muted" style={{ fontSize: "10px", }}>Sub-Total</span>
                        <span className="fs-5 fw-black" >
                            ₹{results.baseAmount.toLocaleString('en-IN')}
                        </span>
                    </div>
                    <span style={{ height: '4rem', width: "2px", background: '#ececec' }} />
                    <div>
                        <span className="fw-medium text-uppercase tracking-wider d-block mb-1 text-muted" style={{ fontSize: "10px", }}>Total Payable</span>
                        <span className="fs-5 fw-black" >
                            ₹{results.totalAmount.toLocaleString('en-IN')}
                        </span>
                    </div>
                </div>
            </div>

            <div>
                <img src={gstImg} alt="gstImage" style={{ width: "42rem" }} />
            </div>
        </div >
    );
};
